import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import objectDetection from "../../Assets/Projects/object-detection.png";
import emotion from "../../Assets/Projects/emotion.png";
import catalogue from "../../Assets/Projects/imdb-catalogue.png";
import imagesearch from "../../Assets/Projects/image-search.png";
import weather from "../../Assets/Projects/weather.png";
import summary from "../../Assets/Projects/summarize.png";
import bookstore from "../../Assets/Projects/bookstore.png";
import facedetection from "../../Assets/Projects/face-detection.png";
import blog from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>Personal projects.</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blog}
              isBlog={false}
              title="React Personal Blog"
              description="An Angular-based blogging application has been developed, utilizing Angular for the front-end and Google Cloud Firebase for the back-end. The technologies employed include Angular, Angular Material, a text editor, and Firebase as a Backend-as-a-Service (BaaS). Google authentication with Firebase has been implemented, enabling users to log in with Google credentials. Once logged in, users with admin access can create, edit, and delete their own blog posts."
              ghLink="https://github.com/sumitsarraf/angular-blog-2"
              demoLink="https://angular-sr-fireblog.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={catalogue}
              isBlog={false}
              title="IMDb catalog"
              description="A web platform that employs the Angular framework and utilizes the themoviedb.org API to showcase a diverse range of movies categorized accordingly."
              ghLink="https://github.com/sumitsarraf/movie-tvseries-catalogue-angular"
              demoLink="https://jolly-squirrel-9de287.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather App"
              description="An Angular Ionic 5 framework was utilized to create a mobile-responsive application specifically designed to display weather information obtained from a weather API."
              ghLink="https://github.com/sumitsarraf/ionic-angular-weather-app"
              demoLink="https://github.com/sumitsarraf/ionic-angular-weather-app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={imagesearch}
              isBlog={false}
              title="Image Search Engine"
              description="This application is built using Angular, and it utilizes the Unsplash API key to retrieve images. Please note that this is solely for educational purposes."
              ghLink="https://github.com/sumitsarraf/angular-image-search"
              demoLink="https://github.com/sumitsarraf/angular-image-search"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={objectDetection}
              isBlog={false}
              title="RealTime Object Detection using TensorflowJS"
              description="A comprehensive application leveraging React.JS and Tensorflow.JS for real-time object detection using COCO SSD"
              ghLink="https://github.com/sumitsarraf/realtime-object-detection-tensorflowjs"
              demoLink="https://github.com/sumitsarraf/realtime-object-detection-tensorflowjs"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={summary}
              isBlog={false}
              title="URL to summary"
              description="Utilizing OpenAI for article summarization enhances readability through URLtoSummary, an open-source article summarizer designed to condense lengthy text articles into concise summaries."
              ghLink="https://github.com/sumitsarraf/article-summary-react"
              demoLink="https://github.com/sumitsarraf/article-summary-react"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bookstore}
              isBlog={false}
              title="Book Hub Library"
              description="A project named 'Book Hub Library,' developed with Angular, showcases a dataset of 1000 popular books. The implementation includes Bootstrap, PrimeNG, and Angular Material."
              ghLink="https://github.com/sumitsarraf/book-hub-library-angular"
              // demoLink="https://github.com/sumitsarraf/book-hub-library-angular"      <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={facedetection}
              isBlog={false}
              title="Face Recognition and Tagging"
              description="This project involves creating a face detection application using the face-api.js JavaScript library and React.js. It includes features such as face recognition, real-time identification of facial landmarks, and expression analysis."
              ghLink="https://github.com/sumitsarraf/face-detection-tagging-react"
              // demoLink="https://github.com/sumitsarraf/face-detection-tagging-react"      <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
